import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { getCurrentUser } from "@/lib/supabase"
import { FullPageSkeleton } from "@/components/ui/skeleton"

export default function HomePage() {
    const navigate = useNavigate()

    useEffect(() => {
        let redirected = false
        const go = (path) => {
            if (redirected) return
            redirected = true
            navigate(path, { replace: true })
        }

        // Safety net: si getCurrentUser tarda más de 3s, redirige ciegamente a /kanban.
        // ProtectedRoute manejará la sesión desde ahí.
        const safetyTimer = setTimeout(() => go("/kanban"), 3000)

        ;(async () => {
            try {
                const { user } = await getCurrentUser()
                clearTimeout(safetyTimer)
                if (user?.isAdmin || user?.rol === "admin") {
                    go("/admin")
                } else {
                    go("/kanban")
                }
            } catch {
                clearTimeout(safetyTimer)
                go("/kanban")
            }
        })()

        return () => clearTimeout(safetyTimer)
    }, [navigate])

    return <FullPageSkeleton message="Preparando tu experiencia..." />
}




